/** Local calendar date as `YYYYMMDD` (matches POS day boundary / BE receipt ids). */
export function localReceiptDatePrefix(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}${m}${d}`;
}

export function receiptIdPrefixForDate(datePrefix: string): string {
  return `RCP-${datePrefix}-`;
}

/** Next receipt id for the day (zero-padded 4-digit sequence). */
export function nextReceiptId(
  datePrefix: string,
  latestReceiptId: string | null | undefined,
): string {
  const prefix = receiptIdPrefixForDate(datePrefix);
  let sequence = 1;
  if (latestReceiptId?.startsWith(prefix)) {
    const parsed = parseInt(latestReceiptId.slice(prefix.length), 10);
    if (Number.isFinite(parsed) && parsed >= 1) {
      sequence = parsed + 1;
    }
  }
  return `${prefix}${sequence.toString().padStart(4, '0')}`;
}
